export default {"src":"/_next/static/media/factsheet.95d745da.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};